// extracted by mini-css-extract-plugin
module.exports = {"banner_wrap":"MethodologyHero_banner_wrap__3WyA1","title":"MethodologyHero_title__7uz6V","description":"MethodologyHero_description__vS12G"};